// @ts-strict-ignore
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { AppRoute } from '../../../models/app.routes.model';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'nav-links',
  templateUrl: './nav-links.component.html',
  styleUrl: './nav-links.component.scss',
})
export class NavLinksComponent implements OnInit, OnDestroy {
  private pageClosed = new Subject<void>();
  @Input() public isFXHPAdmin: boolean;
  @Input() public isFXHPViewer: boolean;
  @Input() public isFXHPRiskManager: boolean;
  @Input() public hasAuditAccess: boolean;
  @Input() public isBlotterTrader: boolean;
  @Input() public isFixingOrderTrader: boolean;
  @Input() public isCreditBank: boolean;
  @Input() public isCreditRiskManager: boolean;
  @Input() public accessibility: boolean;
  public fxhpUser = false;
  public adminRouterLabel = 'Blotter';
  public activeLink: string;
  public links: any;

  public fxhpAdminlinks = [
    { route: 'member-view', label: 'Pools' },
    { route: 'reports', label: 'Reports' },
    { route: 'admin-blotter/blotter', label: this.adminRouterLabel },
    { route: 'rates', label: 'FX Rates' },
    { route: 'credit', label: 'Credit' },
    { route: 'trade-reconciliation', label: 'Recon' },
    { route: 'admin-settings', label: 'Settings' },
  ];
  public memberLinks = [
    { route: 'pools', label: 'Pools' },
    { route: 'reports', label: 'Reports' },
    { route: 'rates', label: 'FX Rates' },
    { route: 'credit', label: 'Credit' },
  ];
  public creditBankLinks = [
    { route: 'reports', label: 'Reports' },
    { route: 'rates', label: 'FX Rates' },
    { route: 'credit-limits', label: 'Credit' },
    { route: 'settings', label: 'Audit' },
  ];
  public fixingOrderTraderLinks = [
    { route: AppRoute.Blotter, label: 'Blotter' },
    { route: 'reports', label: 'Reports' },
    { route: 'rates', label: 'FX Rates' },
  ];

  private readonly userService = inject(UserService);
  private readonly router = inject(Router);

  constructor(private readonly adminService: AdminService) {
    this.router.events.pipe(takeUntil(this.pageClosed)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const activeUrl = this.router.url.substring(
          1,
          this.router.url.indexOf('?'),
        );
        this.activeLink = activeUrl;
      }
    });
  }

  public ngOnInit(): void {
    this.adminService
      .setHeaderForAdmin()
      .pipe(takeUntil(this.pageClosed))
      .subscribe(() => {
        if (sessionStorage.getItem('selectedEntityType') === 'member') {
          this.fxhpAdminlinks[2].label = 'Blotter';
          this.fxhpAdminlinks[2].route = 'admin-blotter/blotter';
        } else {
          this.fxhpAdminlinks[2].label = 'Pricer';
          this.fxhpAdminlinks[2].route = 'admin-blotter/pricer';
        }
      });
    this.fxhpUser =
      this.isFXHPAdmin || this.isFXHPViewer || this.isFXHPRiskManager;
    if (this.fxhpUser) {
      this.links = this.fxhpAdminlinks;
    }

    if (!this.fxhpUser && !this.isCreditBank) {
      if (this.hasAuditAccess) {
        this.memberLinks = [
          ...this.memberLinks,
          { route: 'settings', label: 'Audit' },
        ];
      }
      if (this.isBlotterTrader) {
        this.memberLinks = [
          { route: AppRoute.Blotter, label: 'Blotter' },
          ...this.memberLinks,
        ];
      }
      if (
        this.userService.user$.value?.rolePermissions?.includes('BLOTTER_VIEW')
      ) {
        this.memberLinks.splice(2, 0, {
          route: AppRoute.Blotter,
          label: 'Blotter',
        });
      }
      if (this.isFixingOrderTrader) {
        this.memberLinks = this.fixingOrderTraderLinks;
      }
      this.links = this.memberLinks;
    }
    if (!this.fxhpUser && this.isCreditBank) {
      if (this.isBlotterTrader) {
        this.creditBankLinks.splice(2, 1);
        this.creditBankLinks = [
          { route: 'pricer', label: 'Pricer' },
          ...this.creditBankLinks,
        ];
        this.creditBankLinks.pop();
      }
      this.links = this.creditBankLinks;
    }
  }
  public ngOnDestroy(): void {
    this.pageClosed.next();
    this.pageClosed.complete();
  }
}
